/* eslint-disable no-param-reassign */
import { initialConfig as BarInitialConfig } from '../../charts/Bar';
import { initialConfig as PieInitialConfig } from '../../charts/Pie';
import { initialConfig as lineInitialConfig } from '../../charts/Line';
import { initialConfig as ValueInitialConfig } from '../../charts/Value';
import { initialConfig as RadarInitialConfig } from '../../charts/Radar';
import { initialConfig as MapInitialConfig } from '../../charts/Map';
import { initialConfig as FunnelInitialConfig } from '../../charts/Funnel';
import { initialConfig as RadialBarInitialConfig } from '../../charts/RadialBar';
import { initialConfig as TableInitialConfig } from '../../charts/Table';
import { initialConfig as CalendarInitialConfig } from '../../charts/Calendar';
import { initialConfig as WaffleInitialConfig } from '../../charts/Waffle';
import { initialConfig as BoxPlotInitialConfig } from '../../charts/BoxPlot';
import { initialConfig as ScatterPlotInitialConfig } from '../../charts/ScatterPlot';
import { initialConfig as SubsetTableInitialConfig } from '../../charts/SubsetTable';
import { initialConfig as HistogramInitialConfig } from '../../charts/Histogram';
import { initialConfig as ParetoInitialConfig } from '../../charts/Pareto';
import { initialConfig as BulletInitialConfig } from '../../charts/Bullet';
import { initialConfig as GaugeInitialConfig } from '../../charts/Gauge';

const defaultStyles = {
  Bar: BarInitialConfig,
  Pie: PieInitialConfig,
  Line: lineInitialConfig,
  Value: ValueInitialConfig,
  Radar: RadarInitialConfig,
  Map: MapInitialConfig,
  Funnel: FunnelInitialConfig,
  RadialBar: RadialBarInitialConfig,
  Table: TableInitialConfig,
  Calendar: CalendarInitialConfig,
  Waffle: WaffleInitialConfig,
  BoxPlot: BoxPlotInitialConfig,
  ScatterPlot: ScatterPlotInitialConfig,
  SubsetTable: SubsetTableInitialConfig,
  Histogram: HistogramInitialConfig,
  Pareto: ParetoInitialConfig,
  Bullet: BulletInitialConfig,
  Gauge: GaugeInitialConfig,
};
Object.freeze(defaultStyles);

export default function getDefaultStyle(type) {
  return defaultStyles[type] || {};
}

export const legacyRemap = (config) => {
  if (config.DataFormat?.target || config.DataFormat?.type) {
    config.DataAbsoluteFormat = config.DataAbsoluteFormat ?? 'number';
    config.DataPercentFormat = config.DataFormat?.target ?? 'global';
    config.DataAbsoluteFormatAlt = config.DataAbsoluteFormat ?? 'number';
    config.DataPercentFormatAlt = config.DataFormat?.target ?? 'global';
    switch (config.DataFormat?.type) {
      case 'both':
        config.DataFormat = 'absolute';
        config.DataFormatAlt = 'percentual';
        break;
      case 'both-flip':
        config.DataFormat = 'percentual';
        config.DataFormatAlt = 'absolute';
        break;
      case 'absolute':
        config.DataFormat = 'absolute';
        config.DataFormatAlt = 'none';
        break;
      case 'percentual':
        config.DataFormat = 'percentual';
        config.DataFormatAlt = 'none';
        break;
      default:
        break;
    }
  }
  return config;
};
